/** Outline / solid pairs aligned with mobile MaterialCommunityIcons tab bar. */

const iconClass = 'h-10 w-10 shrink-0';

/** Header menu — same 40×40 footprint and stroke weight as bottom tab icons. */
export function MenuHamburgerIcon() {
  return (
    <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  );
}

type Props = { active: boolean };

export function TabHomeIcon({ active }: Props) {
  if (active) {
    return (
      <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-9.19-9.2A1.5 1.5 0 0012 1.5h-.25a1.5 1.5 0 00-1.13.52L1.48 11.47a.75.75 0 101.06 1.06l8.69-8.69z" />
        <path d="M3.75 13.5v7.125c0 .621.504 1.125 1.125 1.125H9.75V16.5a2.25 2.25 0 012.25-2.25h.75a2.25 2.25 0 012.25 2.25V21.75h4.875c.621 0 1.125-.504 1.125-1.125V13.5" />
      </svg>
    );
  }
  return (
    <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
      />
    </svg>
  );
}

export function TabHistoryIcon({ active }: Props) {
  if (active) {
    return (
      <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path
          fillRule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
          clipRule="evenodd"
        />
      </svg>
    );
  }
  return (
    <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m6.9 0a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
}

export function TabCreateIcon({ active }: Props) {
  if (active) {
    return (
      <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path
          fillRule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm.75 4.5v3.75H16.5a.75.75 0 010 1.5h-3.75V15a.75.75 0 01-1.5 0v-3.75H7.5a.75.75 0 010-1.5h3.75V6.75a.75.75 0 011.5 0z"
          clipRule="evenodd"
        />
      </svg>
    );
  }
  return (
    <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
}

/** Credit-card style — subscription / billing tab. */
export function TabSubscriptionIcon({ active }: Props) {
  if (active) {
    return (
      <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2v2H4V6h16zm0 4H4v8h16v-8z" />
      </svg>
    );
  }
  return (
    <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM2 10h20"
      />
    </svg>
  );
}

export function TabProfileIcon({ active }: Props) {
  if (active) {
    return (
      <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path
          fillRule="evenodd"
          d="M18.685 19.097A9.973 9.973 0 0112 21.75c-2.43 0-4.652-.867-6.378-2.307a9.004 9.004 0 012.2-2.007 3.75 3.75 0 015.175 0 9.004 9.004 0 012.2 2.007zm.094-2.023a8.978 8.978 0 00-2.616-2.17 5.25 5.25 0 00-8.346 0 8.978 8.978 0 00-2.616 2.17M12 9a3 3 0 100-6 3 3 0 000 6zm9.75 3a9.75 9.75 0 11-19.5 0 9.75 9.75 0 0119.5 0z"
          clipRule="evenodd"
        />
      </svg>
    );
  }
  return (
    <svg className={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.926 0m11.926 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
}
